import CustomImageComponent from '@/components/shared/custom/custom-image';
import CustomTooltip from '../tooltip/CustomTooltip';
import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';

const CustomEquipoWithTooltip = ({ src, alt, width, height, label, teamId }) => {
    if (teamId) {
        return (
            <CustomTooltip label={label || alt}>
                <CustomTeamImageWithDefault teamId={teamId} alt={alt} width={width} height={height} />
            </CustomTooltip>
        );
    }

    return (
        <CustomTooltip label={label || alt}>
            <CustomImageComponent src={src} alt={alt} width={width} height={height} />
        </CustomTooltip>
    );
};

export default CustomEquipoWithTooltip;
